import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import React from 'react';
import { useState } from 'react';
import { useCallback } from 'react';
import ConfigurationApiLeagues from './configuratonApiLeagues';
import ConfigurationApiPlayers from './configuratonApiPlayers';
import ConfigurationApiTeams from './configuratonApiTeams';
import ConfigurationApiTournaments from './configuratonApiTournaments';
import ConfigurationApiVenues from './configuratonApiVenues';

const apiTabs = ['Leagues', 'Tournaments', 'Teams', 'Players', 'Venues'];

const ConfigurationApi = ({ sources, sport, onClose, onSave }) => {
  const [value, setValue] = useState("0");

  const handleChange = useCallback((event, newValue) => {
    setValue(newValue);
  }, []);

  return (
    <Box sx={{ background: '#f9f9f9', overflow: 'auto' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            centered
          >
            {apiTabs.map((item, index) => (
              sport.id.toLowerCase() === 'football' && item === 'Players' ? null : <Tab key={index} label={item} value={index.toString()} />
            ))}
          </TabList>
        </Box>
        <TabPanel value={"0"}>
          <ConfigurationApiLeagues sport={sport} sources={sources} onClose={onClose} onSave={onSave} />
        </TabPanel>
        <TabPanel value={"1"}>
          <ConfigurationApiTournaments sport={sport} sources={sources} onClose={onClose} onSave={onSave} />
        </TabPanel>
        <TabPanel value={"2"}>
          <ConfigurationApiTeams sport={sport} sources={sources} onClose={onClose} />
        </TabPanel>
        <TabPanel value={"3"}>
          <ConfigurationApiPlayers sport={sport} sources={sources} onClose={onClose} />
        </TabPanel>
        <TabPanel value={"4"}>
          <ConfigurationApiVenues sport={sport} sources={sources} onClose={onClose} />
        </TabPanel>
      </TabContext>
    </Box>
  );
}

export default ConfigurationApi;
